module.exports = __webpack_public_path__ + "static/3-24f1e54d6f94ec697728d49d97b9e4d6.svg";